import React from "react";

/**
 * Renders table row actions as visible buttons (Edit + Delete style).
 * Used when Table has visibleActions={true}. Same actions API as Actions.js (dropdown).
 */
const VisibleActions = ({ actions, cell, row, rowIndex, formatExtraData }) => {
    if (!actions || !actions.length) return null;

    const handleClick = (e, a) => {
        e.stopPropagation();
        a.action(cell, row, rowIndex, formatExtraData);
    };

    return (
        <div className="d-flex">
            {actions.map((a, i) => {
                const key = `visible-action-${rowIndex}-${i}`;
                if (a.danger) {
                    return (
                        <button
                            aria-label={a.label || "Delete"}
                            className="visible-actions__btn visible-actions__btn--delete"
                            key={key}
                            onClick={e => handleClick(e, a)}
                            type="button"
                        >
                            <i className={a.icon || "fas fa-times"} />
                        </button>
                    );
                }
                return (
                    <button
                        className="visible-actions__btn visible-actions__btn--edit mr-2"
                        key={key}
                        onClick={e => handleClick(e, a)}
                        type="button"
                    >
                        {a.icon && (
                            <i
                                className={`${a.icon} visible-actions__icon mr-1`}
                            />
                        )}
                        {a.label}
                    </button>
                );
            })}
        </div>
    );
};

export default VisibleActions;
